export default __webpack_public_path__ + "static/media/book.05182365.png";